<template>
  <div>
    <h1
      class="mb-[36px] text-center text-[34px] leading-[40px] font-medium text-gray-800 tablet-h:mb-[48px] tablet-h:text-[50px] tablet-h:leading-[58px]"
    >
      Change your plan
    </h1>

    <SelectPlan :type="SelectPlanType.Change" />
  </div>
</template>

<script setup lang="ts">
import SelectPlan from '@/features/billing/components/SelectPlan.vue'
import { SelectPlanType } from '@/shared/types/index'
</script>
